<template>
  <div id="app" class="layout">
    <Subscribe v-if="$route.name == 'subscribe'"/>
    <StatusUpdate v-else-if="$route.name == 'status-update'"/>
    <Demo v-else-if="$route.name == 'demo-form'"/>
    <Layout v-else-if="$route.name == 'reset-password'">
      <ResetPassword/>
    </Layout>
    <Layout v-else-if="!session">
      <Login/>
    </Layout>
    <Layout v-else-if="!company">
      <CompanyList/>
    </Layout>
    <Layout v-else-if="!company.is_initialized">
      <GuidedSetup/>
    </Layout>
    <Layout v-else>
      <MyMenu/>
      <div id="da-content">
        <router-view/>
      </div>
      <Modal v-model="show_card_form" class-name="no-foot">
        <CardForm v-if="show_card_form" @close="show_card_form=false" :edit="card"/>
      </Modal>


      <Modal v-model="show_invoice_form" class-name="no-foot very-large">
        <InvoiceForm v-if="show_invoice_form" @close="show_invoice_form=false" :edit="invoice"/>
      </Modal>
      <Modal v-model="show_contact_form" class-name="no-foot large">
        <ContactForm v-if="show_contact_form" @close="show_contact_form=false" :edit="contact"/>
      </Modal>
      <Modal v-model="show_inventory_form" class-name="no-foot">
        <InventoryForm v-if="show_inventory_form" @close="show_inventory_form=false" :edit="inventory"/>
      </Modal>

    </Layout>
    <iframe name="_print" style="display:none"/>
    <link href="https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:100" rel="stylesheet"/>
  </div>
</template>

<script type="text/javascript">
import Vue from 'vue'
import Login from './views/login'
import MyMenu from './MyMenu'
import CompanyList from './views/centri/list'
import ResetPassword from './views/reset'
import CardForm from './views/soci/card-form'
import GuidedSetup from './views/setup'

import InvoiceForm from './views/contab/invoice-form'
import ContactForm from './views/contab/contact-form'
import InventoryForm from './views/contab/inventory-form'
import Subscribe from './views/subscribe'
import StatusUpdate from './views/status-update'
import Demo from './views/demo-form'

export default {
  store: ['session', 'company'],
  components: {
    InvoiceForm,
    ContactForm,
    Login,
    MyMenu,
    CompanyList,
    ResetPassword,
    CardForm,
    GuidedSetup,
    Subscribe,
    InventoryForm,
    StatusUpdate,
    Demo
  },
  data () {
    return {
      show_card_form: false,
      card: null,
      show_invoice_form: false,
      invoice: null,
      show_contact_form: false,
      contact: null,
      show_inventory_form: false,
      inventory: null,
    }
  },
  mounted () {
    setInterval(() => {
      let cnt = document.querySelectorAll('.ivu-modal-wrap:not(.ivu-modal-hidden)').length
      if (cnt == 0) {
        document.body.style.overflow='auto'
      }
    }, 1500)

    this.$utils.setZoom(this.$utils.getZoom())
    setTimeout(() => {
      document.querySelector('title').innerHTML = this.$store.config.NAME
    })
    this.$root.$on('associate-card.show', card => {
      this.show_card_form = true
      this.card = card
    })
    this.$root.$on('invoice.show', invoice => {
      this.show_invoice_form = true
      this.invoice = invoice
    })
    this.$root.$on('contact.show', contact => {
      this.show_contact_form = true
      this.contact = contact
    })
    this.$root.$on('inventory.show', inventory => {
      this.show_inventory_form = true
      this.inventory = inventory
    })

    // setInterval(() => {
    //   this.$http.post('refresh').then(res => {
    //
    //   })
    // }, 1000)
    Vue.prototype.$success = msg => {
      this.$Message.success({
        duration: 4,
        render: h => h('span', msg)
      })
    }
    Vue.prototype.$error = err => {
      if (typeof err != 'string') {
        console.log(err)
        if (err.body && err.body.error && err.body.error.message) {
          var e = err.body.error
          switch (err.status) {
            case 500:
              err = 'Qualcosa è andato storto'
              break
            case 401:
              err = 'Sessione scaduta'
              break
            case 422:
              err = ['Errore di validazione:']
              for (var i in e.errors) {
                err.push(e.errors[i])
              }
              break
            default:
              err = 'Errore: '+e.message
              if (err.status) err+= ' ('+err.status+')'
          }
        } else {
          err = 'Errore sconosciuto'
        }
      }

      if (typeof err != 'object' || err.constructor.name != 'Array') {
        err = [err]
      }
      this.$Message.error({
        duration: 7,
        render: h => h('span', err.map(line => h('div', line)))
      })
    }

    try {
      this.session = JSON.parse(localStorage.getItem('session'))
    } catch (e) { } // eslint-disable-line no-empty
    this.initialized = true
    this.refresh_int = setInterval(() => {
      if (!this.$store.session) return
      this.$http.post('auth/refresh').then(res => {
        this.$store.session.token = res.data.token
      })
    }, 300000)

    // Disable service workers
    try {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
          registration.unregister()
        } })
    } catch (e) {}





      // Customerly Integration Code
      /*
      window.customerlySettings = {
          app_id: "9468b44e"
      };
      !function(){function e(){var e=t.createElement("script");
      e.type="text/javascript",e.async=!0,
      e.src="https://widget.customerly.io/widget/9468b44e";
      var r=t.getElementsByTagName("script")[0];r.parentNode.insertBefore(e,r)}
      var r=window,t=document,n=function(){n.c(arguments)};
      r.customerly_queue=[],n.c=function(e){r.customerly_queue.push(e)},
      r.customerly=n,r.attachEvent?r.attachEvent("onload",e):r.addEventListener("load",e,!1)}();
      */
  },

  beforeDestroy () {
      this.refresh_int && clearInterval(this.refresh_int)
  },

  watch: {
    '$store.session': {
      deep: true,
      handler (session) {
        if (!this.initialized) return
        localStorage.setItem('session', JSON.stringify(session))
      }
    },
    '$store.company' (c) {
      if (!c) this.$router.push('/')
    }
  }
}
</script>


<style lang="scss">

</style>
